// 公用数据请求
import { getData } from './http';
import Store from '@/store/index';

/**
 * @method 获取步骤页面数据（通用）
 * @param {Number} no  步骤编号
 */
export async function getPageData(no) {
	return getData({ StepNo: no }, 'Users/GetStepInfo');
}

/**
 * @method 保存步骤页面数据（通用）
 * @param {Number} no    保存步骤的编号
 * @param {string} data  页面数据的JSON字符串
 */
export async function savePageData(no, data) { 
    return getData({StepNo: no, Content: data}, 'Users/SaveDisasterContent')
}

/**
 * @method 获取灾害点信息(用于下拉框)
 * @returns 
 */
export async function getPointInfo() { 
    return getData(null, "Users/GetStep401DisasterInfo")
}

/**
 * @method 保存修改状态（重置后面步骤数据）
 * @param {Number} no    保存步骤的编号
 */
export async function saveResetData(no) { 
	return getData({ StepNo: no }, "Users/SaveDisasterStatus")
}

/**
 * @method 获取公共设置
 */
export const getConfig = () => {
	return new Promise((resolve, reject) => {
		getData({}, '/Common/GetConfigs').then((res) => {
			if (!res || res.retCode) reject();
			else {
				Store.commit('updateConfigData', res.data);
				window.systemLang = res.data.region_ver == 'international' ? 'en' : 'zh'
				Store.commit('updateLang', res.data.region_ver == 'international' ? 'en' : 'zh');
				if(res.data.region_ver == 'international') {
					translate.changeLanguage('english');
					translate.listener.isStart = false
				}
				resolve(res.data);
			}
		});
	});
};
